import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

// 创建一个路由器 使用路由懒加载来异步加载文件，防止文件过多的时候文件体积过大影响加载时间
// const Test = resolve => require(['@/components/test.vue'], resolve);



import Index from '@/components/index.vue' //首页
// import Index from '@/components/free/book.vue' //首页
import Login from '@/components/usr/login.vue' //登录页
import AnonymLogin from '@/components/usr/anonymLogin.vue' //登录页
import Logout from '@/components/usr/logOut.vue' //退出页

import About from '@/components/usr/about.vue' //关于我们
import DocQuestion from '@/components/usr/docs/question.vue' //龙猫游疑问解答
import DocAnswer from '@/components/usr/docs/answer.vue' //龙猫游疑问解答
import DocInvoice from '@/components/usr/docs/invoice.vue' //龙猫游疑问解答
import Service from '@/components/usr/docs/service.vue' //龙猫游服务协议
import Privacy from '@/components/usr/docs/privacy.vue' //龙猫游隐私协议

import User from '@/components/usr/user.vue' //个人中心
import MyMember from '@/components/usr/myMember/myMember.vue' //我的下级
import Withdraw from '@/components/usr/withdraw/withdraw.vue' //提现
import WithdrawAccount from '@/components/usr/withdraw/withdrawAccount.vue' //提现到账号
import Payment from '@/components/usr/withdraw/payment.vue' //账号流水
import BindUserPhoneNumber from '@/components/usr/bindUserPhoneNumber.vue' //微信登录绑定手机号码
import ResetPhone from '@/components/usr/resetPhone/resetPhone.vue' //修改手机号码
import HotelList from '@/components/hotel/list.vue' //酒店列表
import HotelDetails from '@/components/hotel/details.vue' //酒店详情
import HotelView from '@/components/hotel/view.vue' //酒店设施详情

import FrHotelList from '@/components/frHotel/list.vue' //海外酒店列表
import FrHotelDetails from '@/components/frHotel/details.vue' //海外酒店详情
import FrHotelView from '@/components/frHotel/view.vue' //酒店设施详情


import Book from '@/components/book/book.vue' //下单
import BookComfain from '@/components/book/bookComfain.vue' //下单支付
import MyOrder from '@/components/usr/myOrder/myOrder.vue' //我的订单列表
import CashBack from '@/components/usr/myOrder/cashBack.vue' //返佣订单列表
import Collect from '@/components/usr/collect/collect.vue' //我的收藏
import History from '@/components/usr/history/history.vue' //我的浏览历史
import MyQr from '@/components/usr/qr/myQr.vue' //我的二维码推广
import BookDetails from '@/components/book/bookDetails.vue' //订单详情
import ReserveDetails from '@/components/book/reserve/bookDetails.vue' //订单详情
import OnlineReserve from '@/components/book/reserve/dailyData.vue' //预定产品下单
import WxPay from '@/components/book/wxPay.vue' //微信支付
import PresaleWxPay from '@/components/activity/wxPay.vue' //预售微信支付
import BaiduMap from '@/components/common/cmpnt/map.vue' //百度地图组件

//抢购，爆款，活动
import ActivityList from '@/components/activity/list.vue' //活动列表
import ActivityDetails from '@/components/activity/details.vue' //活动详情
import ActivityBook from '@/components/activity/book.vue' //活动预订
import ActivityPromote from '@/components/activity/promote.vue' //活动推广
import SaleOrderList from '@/components/usr/myPresaleOrder/myPresaleOrder.vue' //订单列表
import SaleOrderDetails from '@/components/usr/myPresaleOrder/details.vue' //订单详情

//自由行
import FreeList from '@/components/free/list.vue' //自由行列表
import FreeDetails from '@/components/free/details.vue' //自由行详情
import FreeBook from '@/components/free/book.vue' //自由行预定
import FreepPromote from '@/components/free/promote.vue' //自由行推广
import FreeBookComfain from '@/components/free/bookComfain.vue' //自由行预定

//门票
import TicketDetails from '@/components/ticket/details.vue' //门票详情
import TicketView from '@/components/ticket/view.vue' //门票预订
import TicketBook from '@/components/ticket/book/book.vue' //门票列表
import TicketList from '@/components/ticket/list.vue' //门票列表
import BookNotice from '@/components/ticket/book/bookNotice.vue' //门票安全须知

//发票
import Invoice from '@/components/invoice/invoice.vue' //开票信息
import InvoiceList from '@/components/invoice/list.vue' //我的发票
import InvoiceDetails from '@/components/invoice/details.vue' //酒店发票

// 会议
import MeetingList from '@/components/usr/meeting/list.vue' //会议列表
import MeetingDetails from '@/components/usr/meeting/details.vue' //会议详情

//hotel818
import YS88 from "@/components/YS88/YS88.vue";
import Four_puls from "@/components/Four_puls/Four_puls.vue";


//高德地图
import GDmap from "@/components/GDmap/dailyData.vue"; //高德预约界面

import Test from '@/components/test/test.vue' //test



export default new Router({
    routes: [{
        path: '/YS88',
        component: YS88,
        meta: { keepAlive: true }
    }, {
        path: '/four_puls',
        component: Four_puls,
        meta: { keepAlive: true }
    }, {
        path: '/about',
        component: About, //关于我们
        meta: { keepAlive: true }
    }, {
        path: '/service',
        component: Service, //龙猫游服务协议
        meta: { keepAlive: true }
    }, {
        path: '/privacy',
        component: Privacy, //龙猫游隐私协议
        meta: { keepAlive: true }
    }, {
        path: '/docInvoice',
        component: DocInvoice, //龙猫游疑问解答
        meta: { keepAlive: true }
    }, {
        path: '/docQuestion',
        component: DocQuestion, //龙猫游疑问解答
        meta: { keepAlive: true }
    }, {
        path: '/docAnswer',
        component: DocAnswer, //龙猫游疑问解答

    }, {
        path: '/',
        component: Index, //首页
        meta: { keepAlive: true, showContact: true }
    }, {
        path: '/presaleList',
        component: ActivityList, //活动详情

    }, {
        path: '/presaleDetails',
        component: ActivityDetails, //活动详情

    }, {
        path: '/presaleBook',
        component: ActivityBook, //活动预订
    }, {
        path: '/presalePromote',
        component: ActivityPromote, //活动推广
    }, {
        path: '/packageList',
        component: FreeList, //自由行列表
    }, {
        path: '/packageDetails',
        component: FreeDetails, //自由行详情
    }, {
        path: '/packageBook',
        component: FreeBook, //自由行
    }, {
        path: '/packageBookComfain',
        component: FreeBookComfain, //自由行
    }, {
        path: '/packagePromote',
        component: FreepPromote, //自由行推广
    }, {
        path: '/index',
        component: Index, //首页
        meta: { keepAlive: true, showContact: true }
    }, {
        path: '/myOrder',
        component: MyOrder, //我的订单列表
        // meta: { keepAlive: true }
    }, {
        path: '/cashBack',
        component: CashBack, //返佣订单列表
        // meta: { keepAlive: true }
    }, {
        path: '/presaleOrderDetails',
        component: SaleOrderDetails, //我的预售订单详情
        // meta: { keepAlive: true }
    }, {
        path: '/myPresaleOrder',
        component: SaleOrderList, //我的预售订单列表
        // meta: { keepAlive: true }
    }, {
        path: '/bookDetails',
        component: BookDetails, //订单详情
        meta: { singleContact: true }
    }, {
        path: '/reserveDetails',
        component: ReserveDetails, //预约订单详情
    }, {
        path: '/onlineReserve',
        component: OnlineReserve, //产品预约
        // meta: { keepAlive: true }
    }, {
        path: '/user',
        component: User, //个人中心
        // meta: { keepAlive: true }
    }, {
        path: '/myMember',
        component: MyMember, //我的下级
        // meta: { keepAlive: true }
    }, {
        path: '/withdraw',
        component: Withdraw, //提现
        // meta: { keepAlive: true }
    }, {
        path: '/withdrawAccount',
        component: WithdrawAccount, //提现到账号
        // meta: { keepAlive: true }
    }, {
        path: '/payment',
        component: Payment, //提现到账号
        // meta: { keepAlive: true }
    }, {
        path: '/login',
        component: Login, //登录页
        // meta: { keepAlive: true }
    }, {
        path: '/anonymLogin',
        component: AnonymLogin
    }, {
        path: '/logout',
        component: Logout, //退出页
        meta: { keepAlive: true }
    }, {
        path: '/bindUserPhoneNumber',
        component: BindUserPhoneNumber, //微信登录绑定手机号码
        // meta: { keepAlive: true }
    }, {
        path: '/resetPhone',
        component: ResetPhone, //修改手机号码
        // meta: { keepAlive: true }
    }, {
        path: '/collect',
        component: Collect, //我的收藏
        // meta: { keepAlive: true }
    }, {
        path: '/history',
        component: History, //我的浏览历史
        // meta: { keepAlive: true }
    }, {
        path: '/myQr',
        component: MyQr, //我的二维码推广
        // meta: { keepAlive: true }
    }, {
        path: '/frHotelList',
        component: FrHotelList, //海外酒店列表
        meta: { showContact: true }
    }, {
        path: '/frHotelDetails',
        component: FrHotelDetails, //海外酒店详情
        // meta: { keepAlive: true }
    }, {
        path: '/frHotelView',
        component: FrHotelView, //海外设施详情
        // meta: { keepAlive: true }
    }, {
        path: '/hotelList',
        component: HotelList, //国内酒店列表
        meta: { showContact: true }
    }, {
        path: '/hotelDetails',
        component: HotelDetails, //酒店详情
        // meta: { keepAlive: true }
    }, {
        path: '/hotelView',
        component: HotelView, //酒店设施详情
        // meta: { keepAlive: true }
    }, {
        path: '/book',
        component: Book, //下单
        meta: { singleContact: true, styleFlag: true }
    }, {
        path: '/bookComfain',
        component: BookComfain, //下单支付
        meta: { singleContact: true }
    }, {
        path: '/baiduMap',
        component: BaiduMap, //百度地图
        // meta: { keepAlive: true }
    }, {
        path: '/wxPay',
        component: WxPay, //微信支付
        // meta: { keepAlive: true }
    }, {
        path: '/presaleWxPay',
        component: PresaleWxPay, //预售微信支付
        // meta: { keepAlive: true }
    }, {
        path: '/ticketList',
        component: TicketList, //门票列表
        // meta: { keepAlive: true }
    }, {
        path: '/ticketDetails',
        component: TicketDetails, //门票详情
        // meta: { keepAlive: true }
    }, {
        path: '/ticketView',
        component: TicketView, //门票更多详情
        // meta: { keepAlive: true }
    }, {
        path: '/ticketBook',
        component: TicketBook, //门票预订
        // meta: { keepAlive: true }
    }, {
        path: '/bookNotice',
        component: BookNotice, //门票预订
        // meta: { keepAlive: true }
    }, {
        path: '/invoice',
        component: Invoice, //开票信息
        // meta: { keepAlive: true }
    }, {
        path: '/list',
        component: InvoiceList, //我的发票
        // meta: { keepAlive: true }
    }, {
        path: '/invoiceDetails',
        component: InvoiceDetails, //发票详情
        // meta: { keepAlive: true }
    }, {
        path: '/meetingList',
        component: MeetingList, //会议预定
        // meta: { keepAlive: true }
    }, {
        path: '/meetingDetails',
        component: MeetingDetails, //会议预定
        // meta: { keepAlive: true }
    }, {
        path: '/GD/Appointment',
        component: GDmap, //高德预约
        // meta: { keepAlive: true }
    }]

})


// WEBPACK FOOTER //
// ./src/router/index.js